import React from 'react';
import './Wind.Widget.css';

const directions = {
  С: [348.75, 33.75],
  СВ: [33.76, 78.75],
  В: [78.76, 123.75],
  ЮВ: [123.76, 168.75],
  Ю: [168.76, 213.75],
  ЮЗ: [213.76, 258.75],
  З: [258.76, 303.75],
  СЗ: [303.76, 348.74],
};

// расчет текстового представления направления ветра
function directionToString(dir) {
  return Object.keys(directions).find((key, index) => {
    const [min, max] = directions[key];
    if (index === 0 && dir <= min && dir <= max) {
      return true;
    }
    if (dir >= min && dir <= max) {
      return true;
    }
    return false;
  });
}

export default function WindWidget({ size = 24, values }) {
  const [current = '-', direction = 0, max = '-'] = values;
  const unit = 'м/c';

  return (
    <div className="wind-widget-wrapper">
      <div className="wind-widget-wrapper-current">
        <WindIcon size={size} />
        <span className="wind-widget-wrapper-current-value">
          <p>{current}</p>
          <p>{unit}</p>
        </span>
      </div>
      <div className="wind-widget-wrapper-common">
        <div className="wind-widget-wrapper-common-direction">
          <ArrowIcon direction={parseInt(direction, 10)} />
          <p>{directionToString(parseInt(direction, 10))}</p>
        </div>
        <p>{`Макс.: ${max}${unit}`}</p>
      </div>
    </div>
  );
}

function WindIcon({ size }) {
  return (
    <svg width={size} height={size} fill="#1ca5ca" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 4a2 2 0 112 2H4a1 1 0 000 2h8a4 4 0 10-4-4 1 1 0 002 0zM1 9a1 1 0 100 2h7.5a1.5 1.5 0 010 3c-.749 0-1.386-.538-1.52-1.199a1 1 0 10-1.96.398C5.35 14.82 6.83 16 8.5 16a3.5 3.5 0 100-7H1z" fillRule="evenodd" />
    </svg>
  );
}

function ArrowIcon({ direction }) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" role="img" transform={`rotate(${direction})`}>
      <path d="M13.7 6.3l-5-5C8.5 1.1 8.3 1 8 1s-.5.1-.7.3l-5 5c-.2.2-.3.4-.3.7 0 .6.5 1 1 1 .3 0 .5-.1.7-.3L7 4.4V14c0 .6.4 1 1 1s1-.4 1-1V4.4l3.3 3.3c.2.2.4.3.7.3.6 0 1-.4 1-1 0-.3-.1-.5-.3-.7z" fillRule="evenodd" />
    </svg>
  );
}
